import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/users/actions";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { FIRST_NAME, LAST_NAME } from "MODULES/users/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { EMAIL } from "APP_ROOT/constants";
import { properCase } from "LIB/formatters/text";
import AdminFields from "MODULES/users/components/Admin";
import ReduxFormLocationDropdown from "MODULES/Locations/components/ReduxFormLocationsDropdown";
import validate from "./validate";

const formName = "editUser";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name={FIRST_NAME}
              component={FormInput}
              label={properCase(FIRST_NAME)}
              required
            />
          </Col>
          <Col md={6}>
            <Field
              name={LAST_NAME}
              component={FormInput}
              label={properCase(LAST_NAME)}
              required
            />
          </Col>
        </FormRow>
        <Field
          name={EMAIL}
          component={FormInput}
          label={properCase(EMAIL)}
          required
        />
        <ReduxFormLocationDropdown required />
        <AdminFields formName={formName} user={props.user} />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/users/components/EditUser/Form.jsx